import _ from "lodash";
import { DatePicker } from "@mantine/dates";
import moment from "moment";

import React, { useRef } from "react";
import { Text } from "@mantine/core";
import useDeepCompareEffect from "../hooks/useDeepCompareEffect";

const toDate = (raw) => {
  if (raw == null || raw === "") return null;
  if (raw instanceof Date) {
    return Number.isNaN(raw.getTime()) ? null : raw;
  }
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const sameDay = (a, b) => {
  if (a == null || a === "" || b == null || b === "") return false;
  const left = moment(a);
  const right = moment(b);
  if (!left.isValid() || !right.isValid()) return false;
  return left.isSame(right, "day");
};

const addDays = (related, days) => {
  if (related == null || related === "") return null;
  const base = moment(related);
  if (!base.isValid()) return null;
  return base.clone().add(days, "days").toDate();
};

const DateOffPicker = ({
  form: mainForm,
  name,
  label,
  relatedField,
  daysOff = 1,
  editable = false,
  value,
  onChange,
  ...props
}) => {
  const storedValue = _.get(mainForm.values, name);
  const fieldValue = value ?? storedValue;
  const relatedFieldValue = _.get(mainForm.values, relatedField);
  const lastRelatedRef = useRef(undefined);
  const lastAutoRef = useRef(null);

  useDeepCompareEffect(() => {
    const current = _.get(mainForm.values, name);
    const nextValue = addDays(relatedFieldValue, daysOff);
    const isInitial = lastRelatedRef.current === undefined;
    lastRelatedRef.current = relatedFieldValue;

    if (!editable) {
      if (nextValue && !sameDay(current, nextValue)) {
        mainForm.setFieldValue(name, nextValue);
      }
      return;
    }

    if (isInitial) {
      lastAutoRef.current = nextValue;
      if (!toDate(current) && nextValue) {
        mainForm.setFieldValue(name, nextValue);
      }
      return;
    }

    const followedAuto = !toDate(current) || sameDay(current, lastAutoRef.current);
    lastAutoRef.current = nextValue;
    if (!followedAuto || !nextValue || sameDay(current, nextValue)) return;
    mainForm.setFieldValue(name, nextValue);
  }, [relatedFieldValue]);

  if (editable) {
    return (
      <DatePicker
        {...props}
        label={label}
        value={toDate(fieldValue)}
        onChange={onChange}
      />
    );
  }

  return (
    <>
      {fieldValue && (
        <>
          <Text size={14}> {label}</Text>
          <Text size={14} weight={700}>
            {fieldValue ? moment(fieldValue).format("LL") : "----"}
          </Text>
        </>
      )}
    </>
  );
};

export default DateOffPicker;
